import { Link } from 'react-router-dom';
import JsonLd from '../../components/seo/JsonLd';
import SEOHead from '../../components/seo/SEOHead';

export default function PrivacyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/privacy#webpage`,
    url: `${siteUrl}/privacy`,
    name: 'プライバシーポリシー - AIいのちゃん',
    description: 'AIいのちゃんのプライバシーポリシーをご確認ください。',
    inLanguage: 'ja',
    isPartOf: {
      '@id': `${siteUrl}/#website`
    }
  };

  return (
    <>
      <SEOHead 
        title="プライバシーポリシー - AIいのちゃん"
        description="AIいのちゃんのプライバシーポリシーをご確認ください。"
        canonical={`${siteUrl}/privacy`}
      />
      <JsonLd data={jsonLdData} />
      
      <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
        {/* ... existing code ... */}
      </div>
    </>
  );
}